<template>

    <vue-dropzone
        :ref="id"
        :id="id"
        :include-styling="true"
        :options="dzOptions"
        :destroyDropzone="false"
        v-on:vdropzone-mounted="dzInit"
        v-on:vdropzone-drop="dzDrop"
        v-on:vdropzone-file-added="dzFileAdded"
        v-on:vdropzone-files-added="dzFilesAdded"
        v-on:vdropzone-sending="dzSending"
        v-on:vdropzone-success="dzSuccess"
        v-on:vdropzone-success-multiple="dzSuccessMultiple"
        v-on:vdropzone-complete="dzComplete"
        v-on:vdropzone-complete-multiple="dzCompleteMultiple"
        v-on:vdropzone-max-files-exceeded="dzMaxFilesExceeded"
        v-on:vdropzone-max-files-reached="dzMaxFilesReached"
        v-on:vdropzone-removed-file="dzRemovedFile"
        v-on:vdropzone-error="dzError"
        :class="['customdropzone', dzClass]">
    </vue-dropzone>

</template>

<script>
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {

    components: {
        vueDropzone
    },

    props: {
        id: {
            type: String,
            default: 'vueDropzone'
        },
        url: {
            type: String,
            required: true
        },
        autoProcessQueue: {
            type: Boolean,
            default: true
        },
        uploadMultiple: {
            type: Boolean,
            default: false
        },
        thumbnailWidth: {
            type: Number,
            default: 150,
        },
        thumbnailHeight: {
            type: Number,
            default: 80
        },
        maxFiles: {
            type: Number,
            default: null
        },
        maxFilesize: {
          type: Number,
          default: 256
        },
        timeout: {
          type: Number,
          default: 90000
        },
        formDataAppend: {
            type: Array,
            default: null
        },
        dictDefaultMessage: {
            type: String,
            default: 'Datei wählen oder per Drag & Drop hinzufügen'
        },
        acceptedFiles: {
            type: String,
            default: null
        },
        isClickable: {
            type: Boolean,
            default: true
        },
        isEnabled: {
            type: Boolean,
            default: true
        },
        dzClass: {
            type: String,
            default: 'default'
        },
    },


    data: function () {

        return {

            dzOptions: {
                url: '',
                autoProcessQueue: this.autoProcessQueue,
                thumbnailWidth: this.thumbnailWidth,
                thumbnailHeight: this.thumbnailHeight,
                thumbnailMethod: 'contain',
                uploadMultiple: this.uploadMultiple,
                acceptedFiles: this.acceptedFiles,
                clickable: this.isClickable,
                maxFiles: this.maxFiles,
                maxFilesize: this.maxFilesize,
                timeout: this.timeout,
                useFontAwesome: true,
                headers: {
                    "Cache-Control": "",
                    "X-Requested-With": "",
                    "Authorization": 'Basic ' + localStorage.getItem('token')
                },
		            dictDefaultMessage: this.dictDefaultMessage,
                dictMaxFilesExceeded: 'Es können keine weiteren Daten hochgeladen werden.',
        				dictCancelUpload: 'x',
        				dictRemoveFile: 'x',
                dictInvalidFileType: 'Dieser Dateityp ist nicht erlaubt.',
                dictRemoveFileConfirmation: 'Möchten Sie diesen Upload wirklich löschen?',
                addRemoveLinks: true,
                previewTemplate: this.dropzoneTemplate()
            }

        }

    },

    created() {

      //  console.log("acceptedFiles: ", this.acceptedFiles);

      this.dzOptions.url = this.$config.api + this.url;
      // console.log(this.dzOptions);
      /*
      this.dzOptions.headers = {
          "Cache-Control": "",
          "X-Requested-With": "",
          "Authorization": 'Basic ' + this.activeUser.authToken
      }
      */

    },

    mounted() {

        if(this.isEnabled == false) {
            // console.log("disabled ...");
            this.$refs[this.id].disable();
        }


    },

    methods: {

        dzInit() {

            this.$emit('vdropzone-mounted');

        },

        dzDrop(event) {

            this.$emit('vdropzone-drop', event);

        },

        dzFileAdded(file) {

            /*
            if(!file.size) {
                file.size = 0;
            }

            if(!file.type) {
                file.type = "image/*";
            }
            */


            if(this.maxFiles == 1 && this.$refs[this.id].dropzone.files.length > 1) {
                this.$refs[this.id].removeFile(this.$refs[this.id].dropzone.files[0]);
            }

            this.$emit('vdropzone-file-added', file);

        },

        dzFilesAdded(file) {

            this.$emit('vdropzone-files-added', file);

        },

        dzSending(file, xhr, formData) {

            if(this.formDataAppend != null) {

                this.formDataAppend.forEach(function(data) {

                    for (var prop in data) {
                        if(!data.hasOwnProperty(prop)) continue;

                        formData.append(prop, data[prop]);

                    }

                })

            }

            this.$emit('vdropzone-sending', file, xhr, formData);

        },

        dzSuccess(file, response) {

            this.$emit('vdropzone-success', file, response);

        },

        dzSuccessMultiple(files, response) {

            this.$emit('vdropzone-success-multiple', files, response);

        },

        dzComplete(file) {

            this.$emit('vdropzone-complete', file);

        },

        dzCompleteMultiple(files) {

            this.$emit('vdropzone-complete-multiple', files);

        },

        dzRemovedFile(file, error, xhr) {

            this.$emit('vdropzone-removed-file', file, error, xhr);

        },

        dzError(file, message, xhr) {

	        this.$notify.open({content: "Beim Hochladen der Datei trat ein Fehler auf: " + message, type: 'danger'});

        },

        dzMaxFilesExceeded(file) {


        },

        dzMaxFilesReached(file) {


        },

        dropzoneTemplate() {

            return `
            <div class="dz-preview dz-file-preview">

                <div class="dz-image">
                    <img data-dz-thumbnail />
                </div>

                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>

                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>

                <div class="dz-success-mark">
                    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                            <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup">
                            </path>
                        </g>
                    </svg>
                </div>

                <div class="dz-error-mark">
                    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">
                            <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup">
                            </path>
                            </g>
                        </g>
                    </svg>
                </div>

            </div>
            `;

        },

        thumbnail(file, dataUrl) {

            var j, len, ref, thumbnailElement;

            if (file.previewElement) {

                file.previewElement.classList.remove("dz-file-preview");
                ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");

                for (j = 0, len = ref.length; j < len; j++) {
                    thumbnailElement = ref[j];
                    thumbnailElement.alt = file.name;
                    thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
                }

                return setTimeout(((function(_this) {
                    return function() {
                        return file.previewElement.classList.add("dz-image-preview");
                    };
                })(this)), 1);

            }

         }

    }

}

</script>


<style>

    /* main dropzone container */
    .customdropzone {
        position: relative;
        background-color: #fafafa;
        border: 1.2px dashed #dedede;
        transition: background-color .2s linear, border-color .2s linear;
        min-height: 126px;
        width: 100% !important;
        padding: 0 !important;
        border-radius: 3px;
        display: flex;
        flex-wrap: wrap;
    }
    .customdropzone:hover {
        border: 1.2px dashed #cacaca;
    }

    .customdropzone.dz-clickable * {
        cursor: pointer;
    }

    .customdropzone .dz-message {
        width: 100%;
        height: 100%;
        font-size: 12px;
        color: #bbb;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .customdropzone .dz-message span i {
        display: block;
        font-size: 32px;
    }

    /* preview container */
    .customdropzone .dz-preview {
        position: relative !important;
        width: 100px;
        height: 100px;
        background: #fff;
        display: inline-flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin: 5px !important;
    }


    /* remove button */
    .customdropzone .dz-preview .dz-remove {
        position: absolute;
        display: block !important;
        font-family: verdana;
        border: none;
        right:  2px;
        top: 2px;
        bottom: auto;
        margin: 0;
        padding: 0;
        letter-spacing: normal;
        text-align: center;
        cursor: pointer;
        transition: all .2s linear;

        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 7px;
        font-weight: 600;
        background: #f1f1f1;
        color: #444;
    }
    .customdropzone .dz-preview .dz-remove:hover {
        background: #e5e5e5;
        color: #000;
        text-decoration: none;
    }

    /* image container */
    .customdropzone .dz-preview .dz-image {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .customdropzone .dz-preview .dz-image img {
        width: 85%;
        height: 85%;
        object-fit: contain;
    }
    .customdropzone .dz-preview:hover .dz-image img {
        filter: none;
        transform: none;
    }

    /* details */
    .customdropzone .dz-preview .dz-details {
        color: white;
        transition: opacity .2s linear;
        text-align: center;
        display: none;
    }

    /* success and error marks */
    .customdropzone .dz-preview .dz-success-mark,
    .customdropzone .dz-preview .dz-error-mark {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 50;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customdropzone .dz-preview .dz-success-mark svg,
    .customdropzone .dz-preview .dz-error-mark svg {
        width: 24px;
        height: 24px;
    }
    .customdropzone .dz-preview .dz-success-mark path {
        fill: green;
    }
    .customdropzone .dz-preview .dz-error-mark path {
        fill: red;
    }

    /* error message */
    .customdropzone .dz-preview .dz-error-message {
        font-size: 10px;
    }

    .customdropzone .dz-preview.dz-file-preview {
        transition: all .3s ease;
    }
    .customdropzone .dz-preview.dz-file-preview .dz-image {
        border-radius: 4px;
        background: #f1f1f1;
    }

    /* stylings for small (just 1 file) dropzone */
    .customdropzone.dzSingle {
        min-height: 100px;
        height: 100px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customdropzone.dzSingle .dz-preview {
        margin: 0 !important;
        padding: 0 !important;
        height: 85%;
        min-height: auto;
        border-radius: 0;
        border: none;
    }

    .customdropzone.dzSingle .dz-preview .dz-image {
        border: 1px solid #eee;
        border-radius: 4px;
    }
    .customdropzone.dzSingle .dz-preview .dz-image img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    /* for coupon dropzones */
    .customdropzone.dzSingle.coupon {
        width: 150px !important;
    }

    .hidden {
        display: none;
    }

</style>
